import { render, staticRenderFns } from "./SlidersNewOrEdit.vue?vue&type=template&id=0cfe79d8&scoped=true&"
import script from "./SlidersNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./SlidersNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./SlidersNewOrEdit.vue?vue&type=style&index=0&id=0cfe79d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe79d8",
  null
  
)

export default component.exports